const initialState = {};

export default (state = initialState, action) => {
	switch (action.type) {
		case "PHONE_TYPE_IS_LOADING":
			return {
				...state,
				isLoading: 1
			};
		case "PHONE_TYPE_HAS_ERROR":
			return {
				...state,
				isLoading: 0,
				error: action.error
			};
		case "PHONE_TYPE_SUCCESS":
			return {
				...state,
				types: action.data.types,
				isLoading: 0
			};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/phoneTypes.js